/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { MedicalSystemRtSystemDto } from './MedicalSystemRtSystemDto';
import {
    MedicalSystemRtSystemDtoFromJSON,
    MedicalSystemRtSystemDtoFromJSONTyped,
    MedicalSystemRtSystemDtoToJSON,
} from './MedicalSystemRtSystemDto';

/**
 * 
 * @export
 * @interface ODataPostProcessedResultsOfMedicalSystemRtSystemDto
 */
export interface ODataPostProcessedResultsOfMedicalSystemRtSystemDto {
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfMedicalSystemRtSystemDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<MedicalSystemRtSystemDto>}
     * @memberof ODataPostProcessedResultsOfMedicalSystemRtSystemDto
     */
    value?: Array<MedicalSystemRtSystemDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ODataPostProcessedResultsOfMedicalSystemRtSystemDto
     */
    $type?: ODataPostProcessedResultsOfMedicalSystemRtSystemDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfMedicalSystemRtSystemDto
     */
    odataCount?: number;
}


/**
 * @export
 */
export const ODataPostProcessedResultsOfMedicalSystemRtSystemDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoODataPostProcessedResults1PtwPtw100AppZeroApplicationSharedMedicalSystemComponentMedicalSystemRtSystemDtoPtwPtw100AppZeroApplicationSharedPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ODataPostProcessedResults`1[[Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.MedicalSystemRtSystemDto, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ODataPostProcessedResultsOfMedicalSystemRtSystemDtoTypeEnum = typeof ODataPostProcessedResultsOfMedicalSystemRtSystemDtoTypeEnum[keyof typeof ODataPostProcessedResultsOfMedicalSystemRtSystemDtoTypeEnum];



/**
 * Check if a given object implements the ODataPostProcessedResultsOfMedicalSystemRtSystemDto interface.
 */
export function instanceOfODataPostProcessedResultsOfMedicalSystemRtSystemDto(value?: unknown): value is ODataPostProcessedResultsOfMedicalSystemRtSystemDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ODataPostProcessedResultsOfMedicalSystemRtSystemDtoTypeEnum)[0];
}

export function ODataPostProcessedResultsOfMedicalSystemRtSystemDtoFromJSON(json: any): ODataPostProcessedResultsOfMedicalSystemRtSystemDto {
    return ODataPostProcessedResultsOfMedicalSystemRtSystemDtoFromJSONTyped(json, false);
}

export function ODataPostProcessedResultsOfMedicalSystemRtSystemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ODataPostProcessedResultsOfMedicalSystemRtSystemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'value': json['value'] == null ? undefined : ((json['value'] as Array<any>).map(MedicalSystemRtSystemDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
        'odataCount': json['@odata.count'] == null ? undefined : json['@odata.count'],
    };
}

export function ODataPostProcessedResultsOfMedicalSystemRtSystemDtoToJSON(value?: ODataPostProcessedResultsOfMedicalSystemRtSystemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'totalCount': value['totalCount'],
        'value': value['value'] == null ? undefined : ((value['value'] as Array<any>).map(MedicalSystemRtSystemDtoToJSON)),
        '$type': value['$type'],
        '@odata.count': value['odataCount'],
    });
}

